import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';

export function requestingAmountValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^(?=.*[1-9])\d{0,6}(?:\.\d{0,2})?$/)) {
    return { 'invalidMoney': true };
  }
  return null;
}

export function routingNumberValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && control.value !== '') {
    let n = 0;
    const aba = control.value.toString();

    for (let i = 0; i < aba.length; i += 3) {
      n +=
        parseInt(aba.charAt(i), 10) * 3 +
        parseInt(aba.charAt(i + 1), 10) * 7 +
        parseInt(aba.charAt(i + 2), 10);
    }

    if (n !== 0 && n % 10 === 0) {
      return null;
    } else {
      return { 'invalidRouting': true };
    }
  }

  return null;
}

export function srcAcctNumValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^[/*0-9]+$/)) {
    return { 'invalidAcct': true };
  }
  return null;
}

export function srcAcctNameValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^[A-Za-z0-9 \-]+$/)) {
    return { 'invalidName': true };
  }
  return null;
}

